<template>
  <div
    v-if="modal"
    style="
      background-color: #fff;
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      display: grid;
      justify-content: center;
    "
  >
    <div
      @click="(e) => e.stopPropagation()"
      style="
        width: 100%;
        padding: 1rem;
        background-color: #fff;
        border-radius: 0.5rem;
        text-align: start;
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding-top: 2rem;
      "
    >
      <header
        style="display: flex; justify-content: center; align-items: center"
      >
        <div @click="goMap" id="trigger">
          <img src="../assets/arrow-left.svg" /> 戻る
        </div>
        <span style="font-weight: bold; text-align: center">目次</span>
      </header>
      <div class="text-list">
        <div class="link" id="linka">
          <BIconChevronCompactRight color="#2a7fff" /> アカウントを作成する
        </div>
        <div class="link" id="linkb">
          <BIconChevronCompactRight color="#2a7fff" /> 製品見積りプロセス
        </div>
        <span class="link sub" id="linkba">ポスティング</span>
        <span class="link sub" id="linkbb">新聞折込</span>
        <span class="link sub" id="linkbc">DSP配信</span>

        <div class="link" id="linkc">
          <BIconChevronCompactRight color="#2a7fff" /> カートと支払いプロセス
        </div>
        <div class="link" id="linkd">
          <BIconChevronCompactRight color="#2a7fff" /> 注文管理画面
        </div>
        <div class="link" id="linke">
          <BIconChevronCompactRight color="#2a7fff" /> セグメント機能
        </div>
        <div class="link" id="linkg">
          <BIconChevronCompactRight color="#2a7fff" />一括見積もり
        </div>
        <div class="link" id="linkh">
          <BIconChevronCompactRight color="#2a7fff" />見積もり条件検索
        </div>
        <div class="link" id="linkf">
          <BIconChevronCompactRight color="#2a7fff" /> 利用規約
        </div>
      </div>
    </div>
  </div>
  <Header />
  <div class="container container-faq">
    <div class="header">
      <div @click="goMap" class="trigger all">
        <img src="../assets/arrow-left.svg" /> 戻る
      </div>
      <div @click="modal = true" class="trigger">戻る</div>
      <h4>ご利用ガイド</h4>
    </div>
    <div class="main">
      <section id="nav">
        <h4>目次</h4>
        <div class="text-list">
          <div class="link active" id="linka">
            <BIconChevronCompactRight color="#2a7fff" /> アカウントを作成する
          </div>
          <div class="link" id="linkb">
            <BIconChevronCompactRight color="#2a7fff" /> 製品見積りプロセス
          </div>

          <span class="link sub" id="linkba">ポスティング</span>
          <span class="link sub" id="linkbb">新聞折込</span>
          <span class="link sub" id="linkbc">DSP配信</span>

          <div class="link" id="linkc">
            <BIconChevronCompactRight color="#2a7fff" /> カートと支払いプロセス
          </div>
          <div class="link" id="linkd">
            <BIconChevronCompactRight color="#2a7fff" />注文管理画面
          </div>
          <div class="link" id="linke">
            <BIconChevronCompactRight color="#2a7fff" />セグメント機能
          </div>
          <div class="link" id="linkg">
            <BIconChevronCompactRight color="#2a7fff" />一括見積もり
          </div>
          <div class="link" id="linkh">
            <BIconChevronCompactRight color="#2a7fff" />見積もり条件検索
          </div>
          <div class="link" id="linkf">
            <BIconChevronCompactRight color="#2a7fff" />利用規約
          </div>
        </div>
      </section>
      <section id="main">
        <!-- first faq -->
        <div v-if="currentSection == 1">
          <h4 style="font-size: 1.3rem; padding: 2rem">アカウントを作成する</h4>
          <main class="content-faq">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、こちらをクリックしてください。
            </p>
            <HeaderFaq
              title="初めてサイトを開くと、以下のページが表示されますので、ページ右上の「登録はこちら」ボタンをクリックしてください"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-register/1.png"
            />
            <HeaderFaq title="フォームにしっかりと記入すること。" no="2" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-register/2.png"
            />
            <HeaderFaq
              title="登録フォームを完了すると、アカウントを確認するための電子メールが送信されます。そのメールにアクセスし、確認ボタンをクリックしてください。"
              no="3"
            />
            <HeaderFaq
              title="認証されると、アカウントは使用できるようになります。"
              no="4"
            />
          </main>
          <!-- first faq -->
        </div>

        <!-- second faq -->
        <div v-if="currentSection == 2">
          <h4 id="head2" style="font-size: 1.3rem; padding: 2rem 0">
            製品見積りプロセス - ポスティング
          </h4>
          <main class="content-faq">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、こちらをクリックしてください。
            </p>
            <HeaderFaq
              title="初めてウェブサイトを開くと、以下のように表示されます。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/1.png"
            />
            <HeaderFaq
              title="まずは検索セクションで投稿場所を探してみてください。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/2.png"
            />
            <HeaderFaq
              title="さらに、部数、エリア（エリア内ではエリア単位、またはkm単位で選択可能）、印刷オプション（別の場所で印刷、ATOは投函のみ、または印刷と投函を一度に注文）、配達予定日と配布完了希望日、配布方法、用紙サイズなどの情報を入力することができる。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/3.png"
            />
            <HeaderFaq
              title="エリアごとにエリアを選択する場合、地図上でどのエリアを選択するかをクリックすると、青いエリアインジケーターが選択されていないエリア、赤いエリアインジケーターが選択されているエリアになります。"
              no="4"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/4.png"
            />
            <HeaderFaq
              title="ただし、縮尺でエリアを選択した場合は、図のように地図表示が変わるので、縮尺の大きさ（km）を入力するか、地図上の縮尺円上の4点のいずれかをドラッグすることで縮尺幅を指定することができる。"
              no="5"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/5.png"
            />
            <HeaderFaq
              title="エリアごとにエリアを選択する場合、地図上でどのエリアを選択するかをクリックすると、青いエリアインジケーターが選択されていないエリア、赤いエリアインジケーターが選択されているエリアになります。"
              no="6"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/6.png"
            />
            <HeaderFaq
              title="その後、見積結果が表示されますので、見積書を発行する、またはカートに追加するをクリックして続行することができます。"
              no="7"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/7.png"
            />
          </main>
        </div>

        <div v-if="currentSection == 3">
          <h4 style="font-size: 1.3rem; padding: 2rem 0">
            製品見積りプロセス - 新聞折込
          </h4>
          <main class="content-faq">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、こちらをクリックしてください。
            </p>
            <HeaderFaq
              title="初めてウェブサイトを開くと、以下のページが表示されますので、「新聞折込」ボタンをクリックしてください。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/1.png"
            />
            <HeaderFaq
              title="次に、希望する日付を入力し、新聞を発行する人を選び、用紙サイズと紙の厚さを選ぶ。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/2.png"
            />
            <HeaderFaq
              title="使用される面積は縮尺に基づき、縮尺幅は地図上の縮尺円上の4つのポイントのいずれかをドラッグすることで決定できる。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/3.png"
            />
            <HeaderFaq
              title="見積もり結果が表示されますので、「カートに入れる」をクリックしてお進みください。"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/4.png"
            />
          </main>
        </div>

        <!-- Geenie -->
        <div v-if="currentSection == 4">
          <h4 style="font-size: 1.3rem; padding: 2rem 0">
            製品見積りプロセス - DSP配信
          </h4>
          <main class="content-faq">
            <p>
              お支払いの確認と実行のために、このガイドをよくお読みください。
            </p>
            <HeaderFaq title="メニューで「地図から注文」を選ぶ。" no="1" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/1.png"
            />
            <HeaderFaq
              title="DSP配信」タブに入っていることを確認してください。その後、画面左のフォームに入力します。注文名、アップロード画像、ウェブサイトのURL、注文の予算を入力してください。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/2.png"
            />
            <HeaderFaq
              title="ご注文をカートに入れる前に、ご注文内容の確認画面が表示されます。次に進むには、「カートに入れる」ボタンをクリックしてください。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/3.png"
            />
            <HeaderFaq
              title="ご注文がカートに入ったら、メニューに戻ってお支払いを進めてください。"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/4.png"
            />
            <HeaderFaq
              title="カート上の注文リストから、支払いたい注文を承認する。お支払いの前に、必ずご注文の詳細をお読みください。"
              no="5"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/5.png"
            />
            <HeaderFaq
              title="ご希望のお支払い方法をお選びください。ご注文の合計金額が表示されます。その後、お支払いにお進みください。"
              no="6"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/6.png"
            />
            <HeaderFaq
              title="注文の進捗状況を確認するには、メニューの一番下にあるDSP配信注文管理ボタンをクリックします。"
              no="7"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/7.png"
            />
            <HeaderFaq
              title="このセクションには注文リストが表示されます。各オーダーを選択して進捗状況を確認することができます。"
              no="8"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/8.png"
            />
            <HeaderFaq
              title="一つの注文をクリックすると、詳細な注文情報が表示され、注文の進捗状況を確認することができます。"
              no="9"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/9.png"
            />
          </main>
        </div>

        <!-- Geenie -->

        <!-- thrid faq -->
        <div v-if="currentSection == 5">
          <h4 style="font-size: 1.3rem; padding: 2rem 0">
            カートと支払いプロセス
          </h4>
          <main class="content-faq">
            <p>
              お支払いの確認と実行のために、このガイドをよくお読みください。
            </p>

            <HeaderFaq
              title="原稿アップロード期日、納品予定日、配布完了予定日に間違いがないかご確認ください。"
              no="1"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/5.png"
            />
            <HeaderFaq title="金額に間違いがないかご確認ください。" no="2" />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/6.png"
            />
            <HeaderFaq
              title="配布エリアに間違いがないかご確認ください。"
              no="3"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/7.png"
            />
            <HeaderFaq
              title="上記ご確認のうえ問題が無ければ『お支払方法の登録へ進む』追加で注文を行いたい場合は、
『他の注文を追加する』をクリックして下さい"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/8.png"
            />
            <HeaderFaq
              title="配布条件の選択お支払方法を選択してください。"
              no="5"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/9.png"
            />
            <HeaderFaq
              title="クレジットカードをご使用の場合は先に『ここからカード登録と編集』をクリックして作業を進めてください。"
              no="6"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/10.png"
            />
            <HeaderFaq
              title="お支払方法が確定致しましたら『注文の確定』を押して下さい。"
              no="7"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/11.png"
            />
            <HeaderFaq
              title="免責事項が表示されますので最後までお読み頂きチェックボックスにチェックを入れ、『注文確定』ボタンを押してください。"
              no="8"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/12.png"
            />
            <HeaderFaq
              title="ご注文確定後 引き続き、ご注文管理画面より、元データのアップロード、お支払い情報の確認、お届け先の確認をお願いいたします。ご注文確認画面へ進むか、地図へ戻ることができます。"
              no="9"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-cart-payment/13.png"
            />
          </main>
        </div>
        <!-- order management -->
        <div v-if="currentSection == 6">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            注文管理画面
          </h4>
          <main class="content-faq">
            <p>
              カートの手続きを完了した後、注文手続きを完了するには、まず以下の注文条件を満たす必要があります。
            </p>

            <HeaderFaq
              title="こちらから原稿データのアップロード　をお願い致します。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/3.png"
            />
            <HeaderFaq
              title="原稿データのアップロード後に念のためこちらからアップロードデータに間違いが無いかご確認下さい。
 データを変更したい場合は再度『ファイルの選択』を押し、上から再アップロードが可能です。"
              no="2"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/4.png"
            />
            <HeaderFaq
              title="アップロードが完了しましたら、原稿データの審査が完了するまでお待ち下さい。　審査が完了しましたら発送先情報が更新されます。
審査には1～2営業日要する場合がございます。"
              no="3"
            />

            <HeaderFaq
              title="原稿審査が完了しましたら(ご登録されたメールアドレスに完了の連絡が入ります。) こちらより配布物の発送先が情報が更新されますのでご確認いただき、
発送の対応をお願い致します。"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/7.png"
            />
            <HeaderFaq
              title="発送が完了しましたら分かり次第で追跡番号のご入力をお願い致します。
納品予定日までにご納品をお願い致します。"
              no="5"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/8.png"
            />
            <HeaderFaq
              title="発送が完了しましたら分かり次第で追跡番号のご入力をお願い致します。
納品予定日までにご納品をお願い致します。"
              no="6"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/9.png"
            />
            <HeaderFaq
              title="配布が完了しましたら、こちらから報告書のダウンロードが可能となります。"
              no="7"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/10.png"
            />
          </main>
        </div>
        <!-- order management -->
        <!-- segment -->
        <div v-if="currentSection == 7">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            セグメント機能
          </h4>
          <main class="content-faq">
            <HeaderFaq
              title="『セグメント』を押して世帯年収、家族構成、年齢の情報をMAP上に反映する事が可能です。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-segment/1.png"
            />
            <HeaderFaq
              title="セグメント可能な項目が出てきますので、行いたいセグメントにチェックをいれる。
※2項目まで選択可能"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-segment/2.png"
            />
            <HeaderFaq
              title="選択された項目によって、MAP上に色塗りがされますのでこちらを参考にエリアの選定が
可能となります。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-segment/3.png"
            />
          </main>
        </div>
        <!-- segment -->

        <!-- term -->
        <div v-if="currentSection == 8">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            利用規約
          </h4>
          <main class="content-faq">
            <div>
              <div class="section">
                <p class="font-bold">ポスティング</p>
                <!-- {{ getPlans2d() }} -->
                <p>配布エリア、部数、スケジュールについて</p>
                <p style="color: red">
                  エリア選択時に表示される配布部数は、当サービス独自の配布部数を示してお
                  り、選択エリアの全世帯への配布を保証するものではありません。
                </p>
                <p>
                  町丁目ごとの配布部数は、概算のため実際とは異なる可能性がございます。
                </p>
                <p>
                  配布先居住者のご意向による配布拒否、区画整理、住宅事情の変化、配布員確保、交通事情、天災・天候不良等の諸事情により選択エリア内の実配布数が配布見込数を下回った場合又は配布出来ないエリアが生じた場合、残数は、選択エリア近隣に配布されます。
                </p>
                <p>
                  単独の配布ではなく他社広告物と併せて配布を行います。情報誌への挟み込み、丁合を行う場合があります
                </p>
                <p>
                  選択された配布完了希望日どおりの配布をお約束することはできかねます。実際の完了予定日は、入稿データの審査後にご連絡致します。
                </p>
                <p>
                  完了予定日が確定後も決済期日までに決済の確認が行えない、期日までに指定
                  場所への納品が確認できない場合は完了予定日が変更となります。
                </p>

                <p class="font-bold">チラシ内容の審査について</p>
                <p>
                  以下の場合、お断りする場合があります <br />
                  • 法令、または公序良俗に反するもの<br />
                  • 各業界の広告ガイドラインに沿っていないもの<br />
                  • 内容が不明確なもの<br />
                  • 虚偽、誤認の恐れがあるもの<br />
                  • 意見広告<br />
                  • その他、当社が不適切と判断したもの<br />
                </p>
                <p>
                  チラシ内容の審査により、配布対応が不可となる場合や、ご希望のエリアに配
                  布出来ない場合、配布完了日が後ろ倒しになる場合がございます。また、審査
                  には数営業日を要する場合ががございますことを予めご了承下さいませ。
                  配布日に変更があった場合は審査後にお知らせします。
                </p>
                <p class="font-bold">その他注意事項</p>
                <p>
                  原稿審査審査完了後のキャンセルは、全額をキャンセル料として頂戴致しま
                  す。<br />
                  広告内容に因る部分が大きい為、必ずしも反響を保証するものではありません
                  当社判断で投函禁止の基準を設けておりますが、投函禁止の表記によっては投
                  函する場合があります。<br />
                  投函先対応にてお困りの際は当社までご連絡下さい。
                </p>
              </div>

              <!-- section 2 -->
              <div class="section">
                <p class="font-bold">新聞折込広告基準</p>
                <p>
                  チラシ内容の審査について <br /><br />
                  <a href="term_use" target="_blank" style="color: red"
                    >新聞折込広告基準</a
                  >に該当する広告、その他、当社オリコミサービスもしくは新聞<br />
                  販売店が不適切であると判断したものは、お断りする場合があります。<br />
                  以下の場合は、ご希望に沿えない場合がございますことを予めご了承下さいませ。<br />
                  ・チラシ内容の審査により、配布対応が不可またはご希望のエリアに配布出来な<br />
                  い場合、配布日が後ろ倒しになる場合がございます。審査には数営業日を要する<br />
                  場合がございますことを予めご了承下さいませ。<br />
                  ・新聞休刊日や選挙など、新聞発行本社の事情により新聞の発行がない場合<br />
                  ・交通事情や天災・荒天等の事情により、配布日に配布完了できない場合<br />
                  ・大規模災害や不可抗力による事故や事変が発生した場合
                  ※配布日に変更があった場合は、審査後にお知らせします。<br /><br />
                  その他注意事項<br />
                  ・チラシ内容審査後のキャンセルは、全額をキャンセル料として頂戴致します。<br />
                  ・円で選択した配布エリアのすべてに配布するわけではありません。あくまで配
                  布エリアの目安となります。<br />
                  ・配布対象となる新聞販売店は、指定頂いた円に含まれる面積で算出されます。
                  配布の区域指定はできません。<br />
                  ・新聞販売店の配達エリアによって、円外のエリアに配布される場合や、円内の<br />
                  エリアでも配布されない場合がございます。<br />
                  ・販売店の事情による配達エリアの変更、店舗間の合併、分割は予告なく実施さ
                  れます。また、朝刊ではなく夕刊で配布される地域もございます。<br />
                  ・チラシの折込作業上、機械や作業環境（湿度や静電気など）により、チラシが
                  複数枚折りこまれる、もしくは折込漏れがまれに発生する可能性がございます。
                  予めご了承ください。<br />
                  ・広告内容に因る部分が大きい為、必ずしも反響を保証するものではありません。<br />
                </p>
                <!-- <p>
                  日本新聞協会の示した「新聞折込広告基準」に準拠し、次のような折込広告は取り扱いません。
                </p>
                <p>
                  1.責任の所在および内容が不明確な広告
                  広告主名、所在地名、連絡先が記載されていない広告。
                  広告の意味、目的が分からないもの。
                </p>
                <p>
                  2.虚偽または誤認されるおそれがある広告
                  「日本一」「世界一」など最高・最大級の表現、「確実に儲かる」「絶対にやせる」などの断定的表現を何の裏付けもなく使用した広告。
                  「二重価格表示広告」・「おとり広告」は、受けるべきでない。
                </p>
                <p>
                  3.公序良俗を乱す表現の広告
                  露骨な性表現、あるいは暴力や犯罪を肯定・礼賛する広告、麻薬・覚醒剤の使用を賛美したり、その他残虐な表現のある広告。
                </p>
                <p>
                  4.不動産広告
                  不動産広告の表示は、「宅地建物取引業法」などの関係法規、不動産公正取引協議会の「不動産の表示に関する公正競争規約」による。
                </p>
                <p>
                  5.求人広告
                  雇用主の名称・所在地・連絡先、企業の種類と就業する職種など必要な事項が表示されていない広告。
                  「男女雇用均等法」「雇用対策法」に準じたもの。
                  履歴書用紙付求人広告は、履歴書に本籍地・家族関係・宗教・支持政党など差別につながる可能性がある項目があるもの。
                  求人広告に見せかけて講習料をとったり、物品・書籍などを売りつけたりするのが目的である広告。
                </p>
                <p>
                  6.名誉毀損、プライバシーの侵害などのおそれがある広告
                  広告表現中において名誉毀損・プライバシーの侵害・信用毀損・業務妨害となるおそれがあるもの。
                </p>
                <p>
                  7.選挙運動ビラなど<br />
                  選挙運動のための折込広告は、「公職選挙法」の要件を備えたもの以外は配布できない。
                  特に事前運動とみなされるおそれのある広告は、十分な注意が必要である。
                </p>
                <p>
                  8.弁護士の広告<br />
                  弁護士および外国特別会員の業務広告は、日本弁護士連合会の「弁護士の業務広告に関する規程」「外国特別会員の業務広告に関する規程」により定められた範囲内でなければ広告できない。
                </p>
                <p>
                  9.医療関係の広告<br />
                  医業・歯科医業・病院・診療所・助産所などの広告は、医療法に定められた事項以外は広告できない。
                  あん摩業・マッサージ業・柔道整復業などについても関連法規に定められた事項以外は広告できない。
                </p>
                <p>
                  10.医薬品の広告<br />
                  医薬品・医薬部外品・化粧品・医療用具・特定疾病用の医薬品・承認前の医薬品などの広告は、「医薬品等適正広告基準」の範囲内でなければ広告できない。
                </p>
                <p>
                  11.健康食品の広告<br />
                  健康食品の広告は、医薬品的な効能・効果を表示できない。
                </p>
                <p>
                  12.エステティックの広告<br />
                  美顔・痩身などエステ関連広告については、「特定商取引法」で誇大広告の禁止が定められている。〈例〉安全、完璧、日本一、業界一、業界初、絶対、永久、永遠、治療、治すなど。
                </p>
                <p>
                  13.金融関係の広告<br />
                  消費者金融広告などの貸金業の広告では、「貸金業の規則等に関する法律」で利率や登録番号など必要な表示事項を記載するように定められている。貸付条件については、誇大広告は禁止されている。
                  抵当証券業、投資顧問業、金融先物取引業などの広告については関連法規によって虚偽誇大、誤認期待の表現を禁止している。（抵当証券法・投資顧問業法など）
                </p>
                <p>
                  14.個人情報取扱事業者の広告 <br />
                  個人情報保護法により義務づけられる内容が不明確なもの、記載のないもの。（利用目的・利用範囲など）
                </p>
                <p>
                  15.その他 <br />
                  公序良俗に反したり、反社会的な表現の広告、誹謗中傷の恐れのある広告、あるいは迷信などに頼る非科学的な広告。
                  その他、独占禁止法、景品表示法、関係告示、規約に反するもの。
                  上記の他、弊社もしくは新聞販売店が不適切であると判断した場合は、物品受領後であっても新聞折込をお断りする場合がありますので予めご了承ください。
                </p> -->
              </div>
              <!-- section 3 -->
              <div class="section">
                <p class="font-bold">DSP配信</p>
                <p>
                  1.
                  発注者は、本業務に係る広告の内容(適法性・真実性・正確性・第三者の権利の非侵害等)について責任を負い、第三者が、
                  配信された広告の内容に起因する損害賠償請求その他のクレーム(以下「クレーム等」という。)を当社に行った場合、
                  発注者は自己の責任と費用で当該クレーム等を処理するものとし、また、クレーム等によって当社が損害を被った場合、
                  当該損害（弁護士費用を含む。）を賠償するもの致します。ただし、当社に故意又は重過失がある場合はこの限りでは
                  ございません。
                </p>
                <p>
                  2.
                  発注者は当社が提供するタグの利用に際して、タグを設置するウェブサイトのド
                  メイン所有者から利用許諾を得るもの致します。発注者は、当該利用において発生した損害及び当事者間のその他問題に
                  ついて、自らの責任で解決するものとし、当社は一切の責任を負いません。
                </p>
                <p>
                  3.
                  当社は、本業務を行うにあたり、発注者から提示された予算を完全に消化することを保証致しません（実費用に基づく請求となります）
                </p>
              </div>
            </div>
          </main>
        </div>
        <!-- term -->
        <!-- term -->
        <div v-if="currentSection == 10">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            見積もり条件検索
          </h4>
          <main class="content-faq">
            <HeaderFaq
              title="「見積条件の呼出」ボタンをクリックして、見積条件を取得するためのポップアップを開きます。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/1.png"
            />
            <HeaderFaq
              title="開始日と終了日を入力することで、取得したいデータを日付で絞り込むことができます。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/2.png"
            />
            <HeaderFaq
              title="「見積書発行」ボタンをクリックして見積書をダウンロードします。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/3.png"
            />
            <HeaderFaq
              title="「読み込み」ボタンをクリックして、見積条件を開きます。"
              no="4"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/4.png"
            />
            <HeaderFaq
              title="ゴミ箱アイコンボタンをクリックすると、推定条件が削除されます。"
              no="5"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/5.png"
            />
          </main>
        </div>
        <!-- term -->
        <div v-if="currentSection == 9">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            一括見積もり
          </h4>
          <main class="content-faq">
            <HeaderFaq
              title="「一括見積もり」ボタンをクリックして、一括注文の作成を開始してください。"
              no="1"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/1.png" />
            <HeaderFaq
              title="アイコンのゴミ箱ボタンをクリックすることで、選択されているエリアを削除することができます。"
              no="2"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/2.png" />
            <HeaderFaq
              title="選択したエリアをドラッグして移動したり、地図上で右クリックして新しいエリアを作成することもできます。"
              no="3"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/3.png" />
            <HeaderFaq
              title="データが保存されていることを確認してください。赤色はデータがまだ保存されていないことを意味し、黒色はデータが保存されていることを意味します。"
              no="4"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/4.png" />
            <HeaderFaq
              title="データを保存するには、「保存」ボタンを押してデータを保存できます。"
              no="5"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/5.png" />
            <HeaderFaq
              title="次に、以下のフィールドに必要なデータを入力します。"
              no="6"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/6.png" />
            <HeaderFaq
              title="「一括見積」ボタンをクリックして、事前に選択されたエリアの見積もりを表示し、その後、見積もりの総計を計算します。"
              no="7"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/7.png" />
            <HeaderFaq title="詳細情報は見積もり欄で確認できます。" no="8" />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/8.png" />
            <HeaderFaq
              title="その後、「カートへ入れる」ボタンを押して、注文をカートに追加することができます。"
              no="9"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/9.png" />
            <HeaderFaq
              title="ダウンロードボタンを押せば、一括でデータをダウンロードすることもできる。"
              no="10"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/10.png"
            />
            <HeaderFaq
              title="一括データをダウンロードした後、csvドキュメントを開くことができます。"
              no="11"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/11.png"
            />
            <HeaderFaq title="第一は都市" no="12" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/12.png"
            />
            <HeaderFaq title="番目は病棟名 " no="13" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/13.png"
            />
            <HeaderFaq title="3番目は地区名とブロック名である。" no="14" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/14.png"
            />
            <HeaderFaq title="4番目は緯度座標 " no="15" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/15.png"
            />
            <HeaderFaq title="そして5番目は経度座標である" no="16" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/16.png"
            />
            <HeaderFaq
              title="また、マップを介さずに、csv文書で一括注文データを直接編集して一括注文することもできる。"
              no="17"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/17.png"
            />
            <HeaderFaq
              title="その後、csv文書で編集されたデータは、アップロード一括注文ボタンを押してアップロードすることができます。"
              no="18"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/18.png"
            />
            <HeaderFaq
              title="データがアップロードされた後、未保存のストアデータは赤く表示されます。"
              no="19"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/19.png"
            />
            <HeaderFaq
              title="アップロード後、保存ボタンを押してデータを保存します。"
              no="20"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/20.png"
            />
          </main>
        </div>
        <!-- term -->
      </section>
    </div>
  </div>
</template>
<script>
import { BIconChevronCompactRight } from "bootstrap-icons-vue";
import HeaderFaq from "../components/faq/HeaderFaq";
import "../styles/faq.css";
import Header from "../components/Header.vue";

export default {
  name: "FAQ",
  data() {
    return {
      mainContent: "",
      modal: false,
      currentSection: 1,
    };
  },
  components: {
    BIconChevronCompactRight,
    HeaderFaq,
    Header,
  },
  mounted() {
    const add = document.getElementById("main");
    const linka = document.getElementById("linka");
    const linkb = document.getElementById("linkb");
    const linkba = document.getElementById("linkba");
    const linkbb = document.getElementById("linkbb");
    const linkbc = document.getElementById("linkbc");
    const linkc = document.getElementById("linkc");
    const linkd = document.getElementById("linkd");
    const linke = document.getElementById("linke");
    const linkf = document.getElementById("linkf");
    const linkg = document.getElementById("linkg");
    const linkh = document.getElementById("linkh");

    linka.addEventListener("click", () => {
      this.$router.push("/term?section=1");

      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });
      linka.classList.add("active");
      linkb.classList.remove("active");
      linkc.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkb.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkba.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkbb.addEventListener("click", () => {
      this.$router.push("/term?section=3");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbb.classList.add("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkbc.addEventListener("click", () => {
      this.$router.push("/term?section=4");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.add("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkc.addEventListener("click", () => {
      this.$router.push("/term?section=5");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.add("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkd.addEventListener("click", () => {
      this.$router.push("/term?section=6");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.add("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linke.addEventListener("click", () => {
      this.$router.push("/term?section=7");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.add("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkf.addEventListener("click", () => {
      this.$router.push("/term?section=8");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.add("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkg.addEventListener("click", () => {
      this.$router.push("/term?section=9");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.add("active");
      linkh.classList.remove("active");
    });
    linkh.addEventListener("click", () => {
      this.$router.push("/term?section=10");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.add("active");
    });
  },
  updated() {
    if (this.$route.query.section === undefined) {
      this.currentSection = 1;
    } else {
      this.currentSection = this.$route.query.section;
    }

    const add = document.getElementById("main");
    const linka = document.getElementById("linka");
    const linkb = document.getElementById("linkb");
    const linkba = document.getElementById("linkba");
    const linkbb = document.getElementById("linkbb");
    const linkbc = document.getElementById("linkbc");
    const linkc = document.getElementById("linkc");
    const linkd = document.getElementById("linkd");
    const linke = document.getElementById("linke");
    const linkf = document.getElementById("linkf");
    const linkg = document.getElementById("linkg");
    const linkh = document.getElementById("linkh");

    linka.addEventListener("click", () => {
      this.$router.push("/term?section=1");

      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });
      linka.classList.add("active");
      linkb.classList.remove("active");
      linkc.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkb.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkba.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkbb.addEventListener("click", () => {
      this.$router.push("/term?section=3");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbb.classList.add("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkbc.addEventListener("click", () => {
      this.$router.push("/term?section=4");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.add("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkc.addEventListener("click", () => {
      this.$router.push("/term?section=5");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.add("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkd.addEventListener("click", () => {
      this.$router.push("/term?section=6");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.add("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linke.addEventListener("click", () => {
      this.$router.push("/term?section=7");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.add("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkf.addEventListener("click", () => {
      this.$router.push("/term?section=8");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.add("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkg.addEventListener("click", () => {
      this.$router.push("/term?section=9");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.add("active");
      linkh.classList.remove("active");
    });
    linkh.addEventListener("click", () => {
      this.$router.push("/term?section=10");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.add("active");
    });
  },
  methods: {
    goMap() {
      location.href = "/map";
    },
  },
};
</script>
